import { Dispatch } from 'redux';
import { fetcher } from '../../lib/request';

const BENEFITS_SERVER = process.env.REACT_APP_BENEFITS_SERVER;
const BENEFITS_KEY = process.env.REACT_APP_BENEFITS_KEY;

export const GET_RUBRICS_REQUEST = 'GET_RUBRICS_REQUEST';
export const GET_RUBRICS_RESPONSE = 'GET_RUBRICS_RESPONSE';
export const GET_RUBRICS_ERROR = 'GET_RUBRICS_ERROR';

export const SET_ACTIVE_RUBRIC = 'SET_ACTIVE_RUBRIC';

export const getRubricsAction = (
    tariffId: number,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_RUBRICS_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const query = `tariff_id=${tariffId}&lang=${lang}`;
        const response = await fetcher(`${BENEFITS_SERVER}/api/client/v1/rubrics?${query}`)
            .auth(`Basic ${BENEFITS_KEY}`)
            .json();

        dispatch({
            type: GET_RUBRICS_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_RUBRICS_ERROR,
            error
        });
    }
};

export const setActiveRubricAction = (rubricId: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_ACTIVE_RUBRIC,
        activeRubric: rubricId
    });
};



// WEBPACK FOOTER //
// ./src/actions/Benefits/rubrics.ts